import { ProductType, RBTechnical } from 'store/railsBuilder/reducer.types';

export function getTransactionProducts(
    technical: RBTechnical | undefined,
    type: ProductType,
) {
    return technical?.products?.filter((product) => product.type === type);
}
